var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _path, _path2, _path3, _path4, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _path5, _path6, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _path7, _path8, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStateMaster(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 100,
    viewBox: "0 0 120 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 119,
    height: 99,
    rx: 11.5,
    fill: "#F8FBFF",
    stroke: "#EBF1FA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 47.625,
    y: 31.4375,
    width: 13.5,
    height: 44.25,
    fill: "#A2AEE6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 56.625,
    y: 47.9375,
    width: 6.75,
    height: 2.8125,
    rx: 1.40625,
    fill: "#6C7FD8"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 56.625,
    y: 52.625,
    width: 6.75,
    height: 2.8125,
    rx: 1.40625,
    fill: "#6C7FD8"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 56.625,
    y: 57.3125,
    width: 6.75,
    height: 2.8125,
    rx: 1.40625,
    fill: "#6C7FD8"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 56.625,
    y: 62,
    width: 6.75,
    height: 2.8125,
    rx: 1.40625,
    fill: "#6C7FD8"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 56.625,
    y: 66.6875,
    width: 6.75,
    height: 2.8125,
    rx: 1.40625,
    fill: "#6C7FD8"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 74.0625,
    y: 23.75,
    width: 13.5,
    height: 51.9375,
    rx: 6,
    fill: "#A2AEE6"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 36.5625,
    y: 34.25,
    width: 2.0625,
    height: 6.5625,
    rx: 1.03125,
    fill: "#6C7FD8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.7835 42.6875C33.4335 42.6875 33.1585 43.8125 33.1898 44.375V75.6875H52.5023V42.6875H34.7835Z",
    fill: "#6C7FD8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3889 42.6875C33.2186 42.6875 33.1838 43.8125 33.1878 44.375V75.6875H35.625V42.6875H33.3889Z",
    fill: "#4F66D0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.271 38.9375C35.2488 38.9375 35.0406 39.0653 35.0642 39.1293V42.6875H49.6875V38.9375H36.271Z",
    fill: "#6C7FD8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2949 38.9375C35.0983 38.9375 35.0583 39.0653 35.0628 39.1293V42.6875H37.875V38.9375H35.2949Z",
    fill: "#4F66D0"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 39.9375,
    y: 33.5,
    width: 2.0625,
    height: 6.5625,
    rx: 1.03125,
    fill: "#6C7FD8"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 37.125,
    y: 45.875,
    width: 3.5625,
    height: 3.375,
    fill: "white"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 42.375,
    y: 45.875,
    width: 3.5625,
    height: 3.375,
    fill: "white"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 47.625,
    y: 45.875,
    width: 3.5625,
    height: 3.375,
    fill: "white"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 37.125,
    y: 51.5,
    width: 3.5625,
    height: 3.375,
    fill: "white"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 42.375,
    y: 51.5,
    width: 3.5625,
    height: 3.375,
    fill: "white"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 47.625,
    y: 51.5,
    width: 3.5625,
    height: 3.375,
    fill: "white"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 37.125,
    y: 57.125,
    width: 3.5625,
    height: 3.375,
    fill: "white"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 42.375,
    y: 57.125,
    width: 3.5625,
    height: 3.375,
    fill: "white"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 47.625,
    y: 57.125,
    width: 3.5625,
    height: 3.375,
    fill: "white"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 37.125,
    y: 62.75,
    width: 3.5625,
    height: 3.375,
    fill: "white"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 42.375,
    y: 62.75,
    width: 3.5625,
    height: 3.375,
    fill: "white"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 47.625,
    y: 62.75,
    width: 3.5625,
    height: 3.375,
    fill: "white"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 37.125,
    y: 68.375,
    width: 3.5625,
    height: 3.375,
    fill: "white"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 42.375,
    y: 68.375,
    width: 3.5625,
    height: 3.375,
    fill: "white"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 47.625,
    y: 68.375,
    width: 3.5625,
    height: 3.375,
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0335 42.6875C65.6835 42.6875 65.4085 43.8125 65.4398 44.375V75.6875H84.7523V42.6875H67.0335Z",
    fill: "#6C7FD8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M65.6389 42.6875C65.4686 42.6875 65.4338 43.8125 65.4378 44.375V75.6875H67.875V42.6875H65.6389Z",
    fill: "#4F66D0"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 69.9375,
    y: 46.4375,
    width: 16.5,
    height: 3,
    fill: "#4F66D0"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 69.9375,
    y: 51.3125,
    width: 16.5,
    height: 3,
    fill: "#4F66D0"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 69.9375,
    y: 56.1875,
    width: 16.5,
    height: 3,
    fill: "#4F66D0"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 69.9375,
    y: 61.0625,
    width: 16.5,
    height: 3,
    fill: "#4F66D0"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 69.9375,
    y: 65.9375,
    width: 16.5,
    height: 3,
    fill: "#4F66D0"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 69.9375,
    y: 70.625,
    width: 16.5,
    height: 3,
    fill: "#4F66D0"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 76.6875,
    y: 28.625,
    width: 8.0625,
    height: 2.8125,
    fill: "white"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 76.6875,
    y: 33.125,
    width: 8.0625,
    height: 2.8125,
    fill: "white"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 76.6875,
    y: 37.625,
    width: 8.0625,
    height: 2.8125,
    fill: "white"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 75.5,
    width: 60,
    height: 3.5625,
    rx: 1.78125,
    fill: "#BEC6ED"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0127 40.5765C66.0627 41.9265 64.2002 46.5765 63.5127 48.7327C63.1475 49.7827 62.3606 49.1702 62.0127 48.7327L61.6377 47.4202C60.9627 43.8202 57.669 39.9827 56.1065 38.514C51.5315 33.639 52.2627 28.4827 53.2002 26.514C56.1252 20.214 61.9815 19.639 64.544 20.139C72.119 21.864 73.7002 27.5452 73.544 30.1702C73.919 34.1452 70.0127 38.764 68.0127 40.5765Z",
    fill: "#FE646F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4111 33.9688C54.7861 27.8937 58.5049 22.625 60.6924 20.75C53.4924 21.725 52.2549 28.8438 52.5361 32.2812C52.9111 35.5063 55.9424 38.9375 57.4111 40.25C59.9611 42.65 61.5986 46.6875 62.0986 48.4062C62.6986 49.6063 63.5361 48.9062 63.8799 48.4062L65.1924 44.0938C64.5924 42.8937 59.7549 36.8438 57.4111 33.9688Z",
    fill: "#FD4755"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 63.4688,
    cy: 29.8438,
    r: 4.21875,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStateMaster);
export default __webpack_public_path__ + "static/media/state_master.0cfab1ea7c6b5c563d02ceb382516ec0.svg";
export { ForwardRef as ReactComponent };